import { Component, OnInit, Input } from '@angular/core';

class Box{
  constructor(
    public boxBorderColor:string,
    public boxHeaderTitle:string,
    public boxHeaderTitleLink:string='/admin/dashboard',
    public boxHeaderTitleIcon:string,
    public boxContentValue:string
  ){}
}

@Component({
  selector: 'box-dashboard',
  templateUrl: './box-dashboard.component.html',
  styleUrls: ['./box-dashboard.component.css']
})

export class BoxDashboardComponent implements OnInit {

  @Input() box:Box=new Box(
    '#ff0000',
    '/admin/imaliaccounts',
    'Saldos Imali',
    'fa fa-money',
    '10.000,00 Mzn'
  )

  @Input() loadingSpin=false
  constructor() { }

  ngOnInit() {
  }

}
